import { render, staticRenderFns } from "./CardDateDemogr.vue?vue&type=template&id=5dc585dc&"
import script from "./CardDateDemogr.vue?vue&type=script&lang=js&"
export * from "./CardDateDemogr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports